import { config } from '~app/config';

import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { ResponseSuccess } from '@breezeventures/web-lib-ph-request/types';
import { useMutation } from '@tanstack/react-query';

export type ConfirmOcrParams = {
  confirmedResult: {
    idNumber: string;
  };
  transactionId: string;
};

export function useConfirmOcrResult() {
  return useMutation({
    mutationFn: async ({
      confirmedResult,
      transactionId,
    }: ConfirmOcrParams) => {
      const response = await makeRequest<ResponseSuccess<unknown>>({
        url: `${config.apiHost}/kyc/api/v1/confirm_ocr`,
        credentials: 'include',
        cache: false,
        payload: { confirmedResult, transactionId },
      });
      return response.payload;
    },
  });
}
